import { Injectable, inject } from '@angular/core';
import { HttpResourceRequest } from '@angular/common/http';
import { ApiService } from '../Modules/Shared/Services/api.service';
import { endpoints } from '../../environments/endpoints';
import { LaravelDefaultResponse } from '../Modules/Shared/Interfaces/response.interface';
import { AnomaliesReport } from '../Models/avyna/anomalies-report.model';
import { EntraAdminRolesReport } from '../Models/avyna/entra-admin-roles-report.model';
import { M365LicenseAssignmentReport } from '../Models/avyna/m365-license-assignment-report.model';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private readonly _apiService = inject(ApiService);

  anomalies(skipLoading: boolean = true): HttpResourceRequest {
    return this._apiService.get<LaravelDefaultResponse<AnomaliesReport>>(
      endpoints.api.reports.anomalies,
      { skipLoading }
    );
  }

  entraAdminRoles(skipLoading: boolean = true): HttpResourceRequest {
    return this._apiService.get<LaravelDefaultResponse<EntraAdminRolesReport>>(
      endpoints.api.reports.entraAdminRoles,
      { skipLoading }
    );
  }

  m365LicenseAssignment(skipLoading: boolean = true): HttpResourceRequest {
    return this._apiService.get<LaravelDefaultResponse<M365LicenseAssignmentReport>>(
      endpoints.api.reports.m365LicenseAssignment,
      { skipLoading }
    );
  }
}
